/** ケース名など「1, 2, 10」を数値順に並べるための比較（サンプル管理共通） */
const NATURAL_LOCALE = 'ja';
const NATURAL_OPTIONS: Intl.CollatorOptions = { numeric: true, sensitivity: 'base' };

export function compareNaturalStrings(
  a: string | null | undefined,
  b: string | null | undefined
): number {
  return (a ?? '').localeCompare(b ?? '', NATURAL_LOCALE, NATURAL_OPTIONS);
}
